import { Grid, TextField, Typography } from "@mui/material"
import { BLACK, GRAY_LIGHT_RGB_BORDER, GREEN_LOGO, GREEN_MAIN } from "../../theme/colors"
import { useTranslationContext } from "../../hooks/translations/translationsProvider"

interface BankTransferProps {
    // REQUEST ASSO
    amountAvaiable: number,
    assoAmountRequest: string,
    setAssoAmountRequest: React.Dispatch<React.SetStateAction<string>>,
    handleInputAssoChange: (e: React.ChangeEvent<HTMLInputElement>, type: number) => void,
    assoAmountRequestError: boolean, 
    setAssoAmountRequestError: React.Dispatch<React.SetStateAction<boolean>>,
    assoAmountRequestErrorMessage: string,
    typeTab: number,

    // DIVISA (EUR)
    amount: string, 
    divisa: string,

    // FEES
    feeFixedInDivisa: number,
    feePerc: number,
    feePercAmountInDivisa: number,

    handleBlur: (type: number) => void;
}

const BankTransfer:React.FC<BankTransferProps> = ({
    amountAvaiable,
    assoAmountRequest,
    setAssoAmountRequest,
    handleInputAssoChange,
    assoAmountRequestError,
    setAssoAmountRequestError,
    assoAmountRequestErrorMessage, 
    typeTab,

    amount,
    divisa,

    feeFixedInDivisa,
    feePerc,
    feePercAmountInDivisa,

    handleBlur
}) => {
const {t} = useTranslationContext();
    return(
        <>
            <Typography sx={{
                textAlign:'center',
                fontSize: '1.2em',
                letterSpacing:'0.01rem',
                fontWeight:600,
                paddingBottom:1,
            }}>
                {t("Il tuo saldo attuale ASSO sul conto è di")}
            </Typography>

            <Typography sx={{
                textAlign:'center',
                // letterSpacing:'0.015rem',
                fontWeight:'bold',
                fontSize:'1.6em',
                paddingBottom:6
            }}>
                {amountAvaiable.toFixed(2)}
            </Typography>

            <Typography sx={{
                textAlign:'center',
                fontSize: '1em',
            }}>
                {t("Vuoi procurarti altri ASSO?")}
            </Typography>

            <Typography sx={{
                textAlign:'center',
                paddingBottom:6,
                fontSize: '1em',
            }}>
                {t("1 ASSO vale 1 euro. Inserisci qui sotto la quantità di ASSO che desideri acquistare")}
            </Typography>

            <TextField
                fullWidth
                label={t("Quantità ASSO")}
                name="asso"
                onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {(handleInputAssoChange(evt, typeTab ))}}
                onClick={() => {
                    setAssoAmountRequest('')
                    setAssoAmountRequestError(false)
                }}
                onBlur={() => handleBlur(typeTab)}
                value={assoAmountRequest}
                error={assoAmountRequestError}
                helperText={
                    assoAmountRequestError ? assoAmountRequestErrorMessage : ''
                }
                sx={{
                    '& .MuiOutlinedInput-notchedOutline':{
                        borderColor: GREEN_LOGO,
                        color: GREEN_MAIN,
                    },
                    '& .MuiInputLabel-root':{
                        top:-4,
                        fontSize:'1rem',
                        color: GREEN_MAIN,
                    },
                    '& .MuiInputLabel-root.Mui-focused':{
                        color: GREEN_MAIN
                    },
                    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: GREEN_LOGO,
                        color: GREEN_MAIN,
                    },
                    '& .MuiOutlinedInput-input': {
                        padding: '12px 12px',
                        lineHeight: 1.4, 
                        color:"grey", fontSize:'1rem',  
                    },
                    paddingBottom:10,
                }}
            />

            { (assoAmountRequest !== "") &&
                <>
                    <Grid container marginBottom={4}>
                        <Grid item xs={12}>
                            <Typography variant="body1" fontSize={"0.8rem"} textAlign={"left"}>
                                { t("Importo da bonificare") }
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="body1" fontSize={"1.3rem"} textAlign={"left"}  fontWeight={"bold"}>
                                {parseFloat(amount).toFixed(2)} {divisa}
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid container>
                        <Grid item xs={6}>
                            <Typography variant="body1" fontSize={"0.8rem"} textAlign={"left"}>
                                { t("Totale") }
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="body1" fontSize={"0.8rem"} textAlign={"right"}>
                                {parseFloat(amount).toFixed(2)} {divisa}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={6}>
                            <Typography variant="body1" fontSize={"0.8rem"} textAlign={"left"}>
                                {t("Commissione Fissa")}
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="body1" fontSize={"0.8rem"} textAlign={"right"}>
                                {feeFixedInDivisa.toFixed(2)} {divisa}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container marginBottom={2}>
                        <Grid item xs={6}>
                            <Typography variant="body1" fontSize={"0.8rem"} textAlign={"left"}>
                                {t("Commissione Percentuale")} ({feePerc.toFixed(2)} %)
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="body1" fontSize={"0.8rem"} textAlign={"right"}>
                                {feePercAmountInDivisa.toFixed(2)} {divisa}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container marginBottom={5}>
                        <Grid item xs={6}>
                            <Typography variant="body1" fontSize={"0.9rem"} textAlign={"left"}   fontWeight={"bold"}>
                                { t("Accredito netto") }
                            </Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="body1" fontSize={"0.9rem"} textAlign={"right"}  fontWeight={"bold"}>
                                {parseFloat(assoAmountRequest).toFixed(2)} ASSO
                            </Typography>
                        </Grid>
                    </Grid>
                </>
            }
        </>
    )
}

export default BankTransfer;